<template>
  <toggle-button-group :options="directionOptions" @change="handleChange" />
</template>

<script>
import toggleButtonGroup from '../../../toggleButton/toggleButtonGroup.vue';

export default {
  name: 'RidershipDirectionToggle',
  components: { toggleButtonGroup },
  props: {
    selectedDirection: {
      type: String,
      default: 'ALL',
    },
    /**
     * Whether to show the LOOP option. Hidden when the company has no loop
     * routes in the current date range (per spec note).
     */
    showLoop: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    directions() {
      const opts = [
        { value: 'ALL', label: this.$t('flexigo.ridership.allDirections') },
        { value: 'INCOMING', label: this.$t('flexigo.ridership.inbound') },
        { value: 'OUTGOING', label: this.$t('flexigo.ridership.outbound') },
      ];
      if (this.showLoop) {
        opts.push({ value: 'LOOP', label: this.$t('flexigo.ridership.loop') });
      }
      return opts;
    },
    directionOptions() {
      return this.directions.map(({ label, value }) => ({
        label,
        selected: value === this.selectedDirection,
      }));
    },
  },
  methods: {
    handleChange({ index }) {
      this.$emit('change', this.directions[index].value);
    },
  },
};
</script>
